$('document').ready(function(){
    //Touch Punch (draggable Slider)
    $('#money_slider').draggable();
    $('#term_slider').draggable();
});
